import { FormField } from "@components/FormEngine/types";
import { epworthScoreMap, epworthKeys, epworthSleepinessScaleOptions } from "@constants/patientForms";
import { epworthOptions, SleepMedicineHistoryData, EpworthResponseType } from "src/revamp/types/PatientFormTypes";
import _ from "lodash";
import { FormState, FormConfig } from "@components/PatientForms/FormContext/types";

const epworthSleepinessScaleComponent = ({ name, label }: { name: string, label: string }): FormField => ({
	type: "toggle-buttons",
	name: `epworthSleepinessScale.${name}`,
	label,
	options: epworthOptions.map(opt => ({ label: opt, value: opt })),
	fieldProps: {
		labelProps: {
			sx: {
				color: "text.primary",
				fontWeight: "bold",
			},
		},
	},
})

export const epworthSleepinessScaleSchema: FormField[] = [
	{
		type: "group-input",
		name: "epworthSleepinessScale",
		title: "Epworth Sleepiness Scale",
		description: "How likely are you to doze off in the situations below?",
		fieldProps: {
			direction: "column",
			spacing: 2,
		},
		group: epworthSleepinessScaleOptions.map(epworthSleepinessScaleComponent)
	}
]

export const setEpworthToNull = (data: SleepMedicineHistoryData, formState: FormState, formConfig: FormConfig) => {
	const epworthData = data.epworthSleepinessScale;
	if (!formState.completedSteps.includes("epworth-sleepiness-scale") && !formConfig.allowSkipSteps) {
		console.log("setting null")
		for (const key of epworthKeys) {
			epworthData[key] = null;
		}
	}
}

export const calculateEpworthScore = (data: SleepMedicineHistoryData) => {
	const responses = _.values(_.omit(data.epworthSleepinessScale, "score"));
	data.epworthSleepinessScale.score = responses.reduce((acc: number, curr: EpworthResponseType | null) => {
		return acc + (curr ? epworthScoreMap[curr] : 0);
	}, 0);
}

export default epworthSleepinessScaleSchema;